<template>
    <div class='market-title mt-12 fx-v-center color-333'>
        <i class="fs-20 iconfont" :class="iconClass"/>
        <span class="title fw-600 fs-14">{{ title }}</span>
        <span class="des color-999 fs-12">{{ des }}</span>
        <div class="slot"><slot></slot></div>  
    </div>
</template>

<script lang='ts'>
import { createComponent, ref } from '@vue/composition-api'

export default createComponent({
    props: {
        iconClass: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        des: {
            type: String,
            required: true
        }
    }
})
</script>

<style lang="scss" scoped>
.market-title {
    display: flex;
    padding: 6px 12px;
    background-color: #F9F9F9;

    .iconfont::before {
        display: inline-block;
        width: 20px;
        height: 20px;
    }

    .title {
        line-height: 20px;
        margin-left: 4px;
        margin-right: 12px;
    }

    .des {
        line-height: 16px;
    }

    .slot {
        flex: 1;
    }
}
</style>
